import styled from 'styled-components';

const StyledMockupGrid = styled.div`
  position: relative;
  padding-right: 64px;
  padding-left: 64px;
  padding-bottom: ${props =>  props.theme.components_spacing_desk.medium}px;
  &.no--padding{
    padding-bottom: 0;
  }
  .browser--wrap{
    position: relative;
    height: auto;
    max-height: 720px;
    width: 100%;
    overflow: hidden;
    border: 2px solid #000;
  }
  .browser--head{
    position: relative;
    height: 28px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    background-color: #000;
  }
  .browser--head span{
    background-color: #fff;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    margin-right: 8px;
  }
  .browser--head span:nth-child(1){
    margin-left: 16px;
  }
  .browser--body{
    padding-top: 80px;
    display: flex;
    align-items: flex-start;
  }
  .browser--side{
    flex: 0 0 40%;
    max-width: 40%;
    padding-left: 68px;
  }
  .side--lines div{
    border-bottom: 2px solid #BAB9B5;
    margin-bottom: 37px;
  }
  .side--lines div:nth-child(1){
    width: 184px;
  }
  .side--lines div:nth-child(2){
    width: 220px;
  }
  .side--lines div:nth-child(3){
    width: 175px
  }
  .side--lines div:nth-child(4){
    width: 220px
  }
  .side--lines div:nth-child(5){
    width: 110px
  }
  .side--squares{
    padding-top: 60px;
  }
  .square--wrap{
    display: flex;
    align-items:center;
    margin-bottom: 11px;
  }
  .square--wrap .line{
    border-bottom: 2px solid #BAB9B5;
    width: 55px;
  }
  .square--wrap:nth-child(1) .line{
    width: 110px;
  }
  .square--wrap .square{
    position: relative;
    width: 28px;
    height: 28px;
    border: 2px solid #000;
    flex: 0 0 28px;
    margin-right: 18px;
  }
  .browser--grid{
    position: relative;
    flex: 0 0 1278px;
    max-width: 1278px;
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;
  }
  .browser-cell{
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .browser-cell img{
    width: 50%;
   
  }
  .browser-cell .size--handler{
    position: relative;
    width: 80%;
   

  }
  .browser-cell .size--handler img.size--placeholder{
    position: relative;
    width: 100%;
    z-index: 1;
  }
  .browser-cell .size--handler iframe{
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 2;
    top: 0;
    left: 0;
  }
  .browser--cell-lines{
    text-align: center
  }
  .browser--cell-lines div{
    border: 1px solid #000;
    margin: 0 auto;
  }
  .browser--cell-lines div:nth-child(1){
    width: 110px;
    margin-bottom: 26px;
  }
  .browser--cell-lines div:nth-child(2){
    width: 50px;
  }
  .browser--side. .browser--grid{
    padding: 0 68px;
  }
  .browser-cell{
    position: relative;
    width: 592px;
    height: 521px;
    margin-bottom: 47px;
    margin-right: 47px;
    border: 2px solid #000;
    overflow: hidden;
  }
  @media screen and (max-width: 1439px){
    padding-right: 40px;
    padding-left: 40px
  }
  @media screen and (max-width: 1023px){
    padding-bottom: ${props => props.theme.components_spacing_tablet.medium}px;
    .browser--wrap{
      max-height: 600px;
    }
    .browser--body{
      padding-top: 60px;
      flex-direction: column;
    }
    .browser--side{
      flex: 1 1 100%;
      width: 100%;
      max-width: 100%;
      padding: 0;
      display: flex;
      align-items: center;
      justify-content: space-around;
      margin-bottom: 48px;
    }
    .browser--grid{
      flex: 1 1 100%;
      max-width: 100%;
      width: 100%;
      padding: 0 62px;
      text-align: center;
    }
    .browser-cell{
      width: 100%;
      height: auto;
      margin: 0 auto;
      padding: 60px 0;
    }
    .side--squares{
      padding: 0;
    }
    .side--lines div:nth-child(3),
    .side--lines div:nth-child(4),
    .side--lines div:nth-child(5){
      display: none;
    }
  }
  @media screen and (max-width: 767px){
    padding-right: 24px;
    padding-left: 24px;
    padding-bottom: ${props => props.theme.components_spacing_mobile.medium}px;
    .browser--wrap{
      max-height: 450px;
      height: 450px;
    }
    .side--lines div:nth-child(2), .side--squares{
      display: none;
    }
    .browser--grid{
      padding: 0 20px;
    }
    .browser-cell{
      padding: 20px 0;
    }
  }
`;

export {
  StyledMockupGrid
};

